<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }" [draggable]="false" (onHide)="closeDialog()" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-3 w-full">
      <i [class]="logIcon()" [style]="{ 'font-size': '1.5rem' }"></i>
      <div class="flex-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h3 class="m-0 text-black">Log Details</h3>
          <p-tag [value]="log()?.level!.toUpperCase()" [styleClass]="getLevelSeverity(log()?.level || 'info')"
            styleClass="p-1 text-xs font-semibold" />
        </div>
        <small class="text-500 text-black">{{ log()?.timestamp | date: "medium" }}</small>
      </div>
    </div>
  </ng-template>

  @if (log(); as logData) {
  <div class="log-details">
    <!-- Message Section -->
    <div class="section">
      <h4 class="section-title">
        <i class="pi pi-comment mr-2"></i>
        Message
      </h4>
      <div [class]="'message-box ' + getMessageBoxClass(logData.level)">
        <p class="message-text">{{ logData.message }}</p>
      </div>
    </div>

    <p-divider></p-divider>

    <!-- Basic Information -->
    <div class="section">
      <h4 class="section-title">
        <i class="pi pi-info-circle mr-2"></i>
        Basic Information
      </h4>
      <div class="grid">
        <div class="col-12 md:col-6 item-row">
          <label class="detail-label">Log ID</label>
          <p class="detail-value">
            <code class="log-id">{{ logData._id }}</code>
          </p>
        </div>
        <div class="col-12 md:col-6 item-row">
          <label class="detail-label">Application</label>
          <p-chip [label]="logData.application" styleClass="chip-application">
          </p-chip>
        </div>
        <div class="col-12 md:col-6 item-row">
          <label class="detail-label">Log Level</label>
          <div class="d-flex align-items-center gap-1">
            <i [class]="getLevelIcon(logData.level)"></i>
            <span class="text-capitalize">{{ logData.level }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6 item-row">
          <label class="detail-label">Timestamp</label>
          <p class="detail-value d-flex gap-1 align-items-center">
            <i class="pi pi-clock mr-2 text-500"></i>
            {{ logData.timestamp | date: "full" }}
          </p>
        </div>
      </div>
    </div>

    @if (logData.metadata) {
    <p-divider></p-divider>

    <!-- Metadata Section -->
    <div class="section">
      <h4 class="section-title">
        <i class="pi pi-list mr-2"></i>
        Metadata
      </h4>
      <div class="metadata-grid">
        <div class="metadata-card">
          <div class="metadata-icon">
            <i class="pi pi-send"></i>
          </div>
          <div class="metadata-content">
            <label class="metadata-label">HTTP Method</label>
            <p-tag [value]="logData.metadata.methodType" [styleClass]="getMethodSeverity(logData.metadata.methodType)"
              styleClass="p-1 font-semibold" />
          </div>
        </div>

        <div class="metadata-card">
          <div class="metadata-icon">
            <i class="pi pi-globe"></i>
          </div>
          <div class="metadata-content">
            <label class="metadata-label">Original Url</label>
            <p class="metadata-value">
              <code>{{ logData?.metadata?.originalUrl ?? "N/A" }}</code>
            </p>
          </div>
        </div>

        <div class="metadata-card">
          <div class="metadata-icon">
            <i class="pi pi-desktop"></i>
          </div>
          <div class="metadata-content">
            <label class="metadata-label">IP</label>
            <p class="metadata-value">
              <code>{{ logData?.metadata?.ip ?? "N/A" }}</code>
            </p>
          </div>
        </div>

        <div class="metadata-card">
          <div class="metadata-icon">
            <i class="pi pi-shield"></i>
          </div>
          <div class="metadata-content">
            <label class="metadata-label">Protocol</label>
            <p class="metadata-value">
              <code>{{ logData?.metadata?.protocol ?? "N/A" }}</code>
            </p>
          </div>
        </div>
      </div>
    </div>
    }

    <div class="card flex justify-center">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Body</p-accordion-header>
          <p-accordion-content>
            <p class="m-0">{{logData?.metadata?.body ?? "N/A"}}</p>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="1">
          <p-accordion-header>Param</p-accordion-header>
          <p-accordion-content>
            <p class="m-0">{{logData?.metadata?.params ?? "N/A"}}</p>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="2">
          <p-accordion-header>Query</p-accordion-header>
          <p-accordion-content>
            <p class="m-0">{{logData?.metadata?.query ?? "N/A"}}</p>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <p-divider></p-divider>

    <!-- Timeline Section -->
    <div class="section">
      <h4 class="section-title">
        <i class="pi pi-calendar mr-2"></i>
        Timeline
      </h4>
      <div class="timeline-info">
        <div class="timeline-item">
          <i class="pi pi-calendar-plus text-blue-500"></i>
          <div>
            <label class="timeline-label">Date</label>
            <p class="timeline-value">
              {{ logData.timestamp | date: "fullDate" }}
            </p>
          </div>
        </div>
        <div class="timeline-item">
          <i class="pi pi-clock text-purple-500"></i>
          <div>
            <label class="timeline-label">Time</label>
            <p class="timeline-value">
              {{ logData.timestamp | date: "longTime" }}
            </p>
          </div>
        </div>
        <div class="timeline-item">
          <i class="pi pi-history text-orange-500"></i>
          <div>
            <label class="timeline-label">Relative Time</label>
            <p class="timeline-value">
              {{ getRelativeTime(logData.timestamp) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</p-dialog>